import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "432",
  height: "216"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "ete899btoa",
        x1: "-4.623%",
        x2: "150.822%",
        y1: "62.591%",
        y2: "22.106%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#D8E5C4",
          "stop-opacity": ".25"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#D8E5C4"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#ete899btoa)",
      "fill-rule": "evenodd",
      d: "M249.958 0c70.704 0 134.625 29.108 180.486 76.02v93.589C398.9 101.349 329.946 54 249.958 54 152.87 54 72.038 123.759 54.63 216H0C17.977 93.794 123.04 0 249.958 0",
      transform: "rotate(180 215.72 108)"
    }, null, -1)
  ])))
}
export default { render: render }